import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ImportResult } from '@shared/classes/import-result';
import { Utilities } from '@shared/utils/utilities';

@Pipe({
  name: 'importResultErrorMessageTranslate',
  standalone: true
})
export class ImportResultErrorMessageTranslate implements PipeTransform {
  translateService = inject(TranslateService);

  constructor() { }

  transform(value: string, importResult: ImportResult) {
    if (value === null || value === undefined || !importResult) {
      return "";

    }

    var translatedValue = this.translateService.instant(value) as string;
    if (importResult.errorArgs && importResult.errorArgs.length > 0) {
      importResult.errorArgs.forEach((errorArg, index) => {
        translatedValue = translatedValue.replace(`{${index}}`, errorArg);
      });
    }

    if (Utilities.isEmptyString(importResult.errorMessage)) {
      return translatedValue;
    }

    return `${translatedValue} ${importResult.errorMessage}`;
  }
}
